import { useEffect, useRef } from "react";
import QRCode from "qrcode";

interface BinLabelProps {
  qrValue: string;
  binCode: string;
  locationName?: string | null;
  description?: string | null;
  qrSize?: number;
}

export function BinLabel({
  qrValue,
  binCode,
  locationName,
  description,
  qrSize = 110,
}: BinLabelProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current && qrValue) {
      QRCode.toCanvas(canvasRef.current, qrValue, { width: qrSize, margin: 1 }, (err) => {
        if (err) console.error("QR generation error:", err);
      });
    }
  }, [qrValue, qrSize]);

  return (
    <div className="bg-card text-card-foreground border border-border rounded-2xl p-5 shadow-lg ring-1 ring-border/50 print:break-inside-avoid print:border-black print:bg-white print:text-black print:rounded-none print:shadow-none print:ring-0 w-full">
      <div className="bg-foreground text-background px-3 py-2 print:bg-black print:text-white">
        <p className="text-lg font-extrabold leading-tight break-words">{binCode}</p>
      </div>
      <div className="mt-3 grid grid-cols-[1fr_auto] gap-4">
        <div className="min-w-0 flex flex-col justify-between gap-3">
          <div className="min-w-0">
            <p className="text-sm font-mono break-all">{locationName || "—"}</p>
            {description ? (
              <p className="mt-1 text-sm font-medium break-words">{description}</p>
            ) : null}
          </div>
        </div>
        <canvas ref={canvasRef} width={qrSize} height={qrSize} className="flex-shrink-0 self-start" />
      </div>
    </div>
  );
}
